// src/components/AgreementModal.jsx
import React from 'react';

class AgreementModal extends React.Component {
  render() {
    const { isOpen, agreement, onConsent } = this.props;

    if (!isOpen) return null;

    const title =
      (agreement && agreement.title) ||
      'User Testing and Confidentiality Agreement';

    const content =
      (agreement && agreement.content) ||
      'You have a new agreement to review. Please accept or decline to continue.';

    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div className="bg-white rounded-2xl shadow-2xl w-[900px] h-[1200px] p-10 flex flex-col">
          <h2 className="text-2xl font-bold mb-4 text-sky-900 text-center">
            {title}
          </h2>
          <p className="text-gray-600 text-base mb-4 text-center">
            Please review and indicate your consent to continue using the app.
          </p>

          <div className="flex-1 bg-gray-50 border rounded-xl p-6 overflow-y-auto whitespace-pre-line text-base text-gray-800 mb-6 leading-relaxed">
            {content}
          </div>

          <div className="flex justify-end gap-4 mt-4">
            <button
              type="button"
              onClick={() => onConsent && onConsent('no')}
              className="px-6 py-3 rounded-lg bg-gray-200 hover:bg-gray-300 text-base font-medium"
            >
              Decline
            </button>
            <button
              type="button"
              onClick={() => onConsent && onConsent('yes')}
              className="px-6 py-3 rounded-lg bg-sky-600 hover:bg-sky-700 text-white text-base font-semibold shadow"
            >
              I Agree
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AgreementModal;
